<template>
  <div class="flex flex-row justify-around">
    <AtomSpinner
      class="mt-5 mb-5"
      :animation-duration="1000"
      :size="60"
      :color="'#7367F0'"
    />
  </div>
</template>

<script>
import { AtomSpinner } from "epic-spinners";

export default {
  name: "AtomSpinnerCentred",
  components: { AtomSpinner }
};
</script>
